function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { isAfter } from "date-fns";
import * as R from "ramda";
import { useCallback, useState } from "react";
import { FILTER_OPERATORS, FILTER_TYPES } from "../types";
import { formatDateTime, formatDateTimeISO } from "../utils/date-time";
import { isArrayOfStrings, isString } from "../utils/validators";
var isEmptyString = function(value) {
    return typeof value === "string" ? !value.trim() : false;
};
export var useFilter = function(rules, values) {
    var date_range = rules.date_range, eq = rules.eq, every = rules.every, ilike = rules.ilike, in_range = rules.in_range, is_null = rules.is_null, like = rules.like, nilike = rules.nilike, some = rules.some;
    var validateDateRangeFilter = useCallback(function(fieldName, value) {
        if (!(date_range === null || date_range === void 0 ? void 0 : date_range.includes(fieldName))) {
            return false;
        }
        if (!Array.isArray(value) || value.length !== 2) {
            throw new Error("The ".concat(fieldName, ' is a date_range field. It should be a tuple of Date objects, but "').concat(value, '" is given.'));
        }
        if (Object.prototype.toString.call(value[0]) !== "[object Date]" || Object.prototype.toString.call(value[1]) !== "[object Date]") {
            throw new Error("The ".concat(fieldName, ' field should contain valid Date objects, but "').concat(value, '" is given.'));
        }
        if (!isAfter(value[1], value[0])) {
            throw new Error("The second date (".concat(formatDateTime(value[1]), ") should be after the first date (").concat(formatDateTime(value[0]), ") in ").concat(fieldName, "."));
        }
        return true;
    }, [
        date_range
    ]);
    var processBooleanValue = useCallback(function(fieldName, value) {
        if (is_null === null || is_null === void 0 ? void 0 : is_null.includes(fieldName)) {
            return _define_property({}, FILTER_TYPES.is_null, value);
        } else if (eq === null || eq === void 0 ? void 0 : eq.includes(fieldName)) {
            return _define_property({}, FILTER_TYPES.eq, value);
        } else {
            throw new Error("No rule found for boolean field ".concat(fieldName, "."));
        }
    }, [
        eq,
        is_null
    ]);
    var processStringValue = useCallback(function(fieldName, value) {
        if (is_null === null || is_null === void 0 ? void 0 : is_null.includes(fieldName)) {
            return _define_property({}, FILTER_TYPES.is_null, value === "true");
        } else if (eq === null || eq === void 0 ? void 0 : eq.includes(fieldName)) {
            return _define_property({}, FILTER_TYPES.eq, value.trim());
        } else if (like === null || like === void 0 ? void 0 : like.includes(fieldName)) {
            return _define_property({}, FILTER_TYPES.like, "%".concat(value.trim(), "%"));
        } else if (ilike === null || ilike === void 0 ? void 0 : ilike.includes(fieldName)) {
            return _define_property({}, FILTER_TYPES.ilike, "%".concat(value.trim(), "%"));
        } else if (nilike === null || nilike === void 0 ? void 0 : nilike.includes(fieldName)) {
            return _define_property({}, FILTER_TYPES.nilike, "%".concat(value.trim(), "%"));
        } else {
            throw new Error("No rule found for string field ".concat(fieldName, "."));
        }
    }, [
        eq,
        ilike,
        is_null,
        like,
        nilike
    ]);
    var processArrayOfStrings = useCallback(function(fieldName, values) {
        if (is_null === null || is_null === void 0 ? void 0 : is_null.includes(fieldName)) {
            return values.map(function(value) {
                return _define_property({}, FILTER_TYPES.is_null, value === "true");
            });
        } else if (in_range === null || in_range === void 0 ? void 0 : in_range.includes(fieldName)) {
            // Convert string values to boolean if possible
            var convertedValues = values.every(function(item) {
                return [
                    "true",
                    "false"
                ].includes(item);
            }) ? values.map(function(item) {
                return item === "true" ? true : item === "false" ? false : item;
            }) : values;
            return _define_property({}, FILTER_TYPES.in, convertedValues);
        } else if (every === null || every === void 0 ? void 0 : every.includes(fieldName)) {
            return values.map(function(value) {
                return _define_property({}, FILTER_TYPES.eq, value.trim());
            });
        } else if (some === null || some === void 0 ? void 0 : some.includes(fieldName)) {
            return values.map(function(value) {
                return _define_property({}, FILTER_TYPES.eq, value.trim());
            });
        } else {
            throw new Error("No rule found for array of strings field ".concat(fieldName, "."));
        }
    }, [
        every,
        in_range,
        is_null,
        some
    ]);
    var processDateRange = useCallback(function(value) {
        var _obj;
        return _obj = {}, _define_property(_obj, FILTER_TYPES.gt, formatDateTimeISO(value[0])), _define_property(_obj, FILTER_TYPES.lte, formatDateTimeISO(value[1])), _obj;
    }, []);
    var handle = useCallback(function(fieldName, value) {
        if (validateDateRangeFilter(fieldName, value)) {
            return processDateRange(value);
        } else if (typeof value == "boolean") {
            return processBooleanValue(fieldName, value);
        } else if (isString(value)) {
            return processStringValue(fieldName, value);
        } else if (isArrayOfStrings(value)) {
            return processArrayOfStrings(fieldName, value);
        }
        throw new Error("No rule found for the field ".concat(fieldName, "."));
    }, [
        processArrayOfStrings,
        processBooleanValue,
        processDateRange,
        processStringValue,
        validateDateRangeFilter
    ]);
    var convertFilter = useCallback(function(params) {
        if (!params) {
            return;
        }
        var filterParams = {};
        var assocPath = function(fieldName, value) {
            var obj = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : filterParams;
            return R.assocPath(fieldName.split("."), value, obj);
        };
        var assocFieldName = R.curry(function(fieldName, value) {
            var operator = (every === null || every === void 0 ? void 0 : every.includes(fieldName)) ? FILTER_OPERATORS.and : FILTER_OPERATORS.or;
            if (Array.isArray(value)) {
                var pathsArray = value.map(function(val) {
                    return R.assocPath(fieldName.split("."), val, {});
                });
                return assocPath(operator, pathsArray);
            }
            return assocPath(fieldName, value);
        });
        // Store filter parameters in flat key-value structure
        var flatFilterParams = params;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(params)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = _sliced_to_array(_step.value, 2), fieldName = _step_value[0], value = _step_value[1];
                if (!value || isEmptyString(value)) {
                    continue;
                }
                var assignValue = assocFieldName(fieldName);
                filterParams = R.pipe(handle, assignValue)(fieldName, value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            filterParams: filterParams,
            flatFilterParams: flatFilterParams
        };
    }, [
        every,
        handle
    ]);
    var setValues = useCallback(function(params) {
        setFilter(convertFilter(params));
    }, [
        convertFilter
    ]);
    var _useState = _sliced_to_array(useState(convertFilter(values)), 2), filter = _useState[0], setFilter = _useState[1];
    return [
        filter === null || filter === void 0 ? void 0 : filter.filterParams,
        setValues,
        filter === null || filter === void 0 ? void 0 : filter.flatFilterParams
    ];
};

//# sourceMappingURL=useFilter.js.map